import React, { Component } from "react";

import { defined } from "@formant/core/common/defined";
import { ITeam } from "@formant/core/model/ITeam";

import { appStore, teamStore } from "../../../stores";
import { Buttons } from "../../common/Buttons";
import { ActionButton } from "../ActionButton";

export interface IActionsProps {
    team: ITeam;
}

export class Actions extends Component<IActionsProps> {
    public render() {
        return (
            <Buttons>
                <ActionButton icon="delete" onClicked={this.onDelete} />
            </Buttons>
        );
    }

    private onDelete = () => {
        const { team } = this.props;
        appStore.setConfirm({
            title: "Delete team",
            message: `Delete team "${team.name}"?`,
            onOk: async () => {
                try {
                    await teamStore.delete(defined(team.id));
                } catch (error) {
                    appStore.setSnackbar(
                        "Failed to delete team. Teams with users cannot be deleted",
                    );
                    return;
                }
                appStore.setSnackbar("Team deleted");
            },
        });
    };
}
